import user from './user'
import apiaries from './apiaries'
import colonies from './colonies'
import queens from './queens'
import measures from './measures'
import ratings from './ratings'
import notes from './notes'
import axios from 'axios'
import rateLimit from 'axios-rate-limit'
import config from '@/config'

const Api = function (options) {
  this.axios = options.axios || rateLimit(axios.create(), { maxRequests: 5, perMilliseconds: 1000 })
  this.config = options.config || config
  this.user = user(this.axios, this.config)
  this.apiaries = apiaries(this.axios, this.config)
  this.colonies = colonies(this.axios, this.config)
  this.queens = queens(this.axios, this.config)
  this.measures = measures(this.axios, this.config)
  this.ratings = ratings(this.axios, this.config)
  this.notes = notes(this.axios, this.config)

  this.invalidateAll = function () {
    this.apiaries.invalidate()
    this.colonies.invalidate()
    this.queens.invalidate()
    this.measures.invalidate()
    this.ratings.invalidate()
    this.notes.invalidate()
  }
}

// Vue-Plugin
Api.install = function (Vue) {
  Vue.mixin({
    beforeCreate () {
      if (this.$options.api) {
        this.$api = this.$options.api
      } else {
        this.$api = this.$parent && this.$parent.$api
      }
    }
  })
}

export default Api
